<template lang="pug">
#app
  v-container(grid-list-md, fluid)
    v-layout(v-if="$root.user.permissao != 0", row, wrap)
      AccessLock
    v-layout(v-if="$root.user.permissao == 0", row, wrap)
      v-flex(lg12)
        form(@submit.prevent="salvar")
          v-card.elevation-1
            v-card-text
              v-layout(row, wrap)
                v-flex.md6.xs12
                  v-autocomplete(label="Selecione um questionário", :items="listQuestionarios", :disabled="!listQuestionarios.length", item-text="nome", item-value="id", color="gray", v-model="categoria_questao.questionario_id", :loading="loadingQuestionarios", :clearable="true", autocomplete, :filter="customFilter", required, v-validate="'required'")
                v-flex.md6.xs12
                  v-text-field(label="Nome", color="gray", required, v-validate="'required'", :error-messages="errors.collect('texto')", data-vv-name="texto", data-vv-as="Texto", type="text", v-model='categoria_questao.texto')
              v-layout(row, wrap)
                v-flex.xs12
                  v-btn(type="submit", color="bt-primary", :loading='loading').white--text Salvar
</template>

<script>
import _ from 'lodash';
import AccessLock from '@/components/AccessLock';

export default {
  components: {
    AccessLock
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    loading: false,
    categoria_questao: {},
    loadingQuestionarios: false,
    listQuestionarios: [],
  }),
  mounted () {
    const vm = this;
    if (vm.$route.params.id) {
      vm.getCategoriaQuestao(vm.$route.params);
    }
    vm.getQuestionarios();
  },
  methods: {
    async save (categoria_questao) {
      const vm = this;
      try {
        const response = await vm.$axios.post('/categoria-questao', categoria_questao);
        categoria_questao.id = response.data.id;
        vm.$router.push({ name: 'CategoriaQuestaoLista', params: { id: response.data.id } });
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Categoria de questão salva com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar a categoria de questão. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async update (categoria_questao) {
      const vm = this;
      try {
        if (categoria_questao.QuestionarioId) delete categoria_questao.QuestionarioId;
        const response = await vm.$axios.put(`/categoria-questao/${categoria_questao.id}`, categoria_questao);
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: 'Categoria de questão salvo com sucesso!' });
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao atualizar a categoria de questão. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async salvar (scope) {
      const vm = this;
      try {
        vm.loading = true;  
        const result = await vm.$validator.validateAll();
        if (!result) throw 'Preencha todos os campos corretamente!';
        vm[vm.categoria_questao.id ? 'update' : 'save'](vm.categoria_questao);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },
    async getCategoriaQuestao (params) {
      let vm = this;
      try {
        const response = await vm.$axios.get(`/categoria-questao/${params.id}`);
        vm.categoria_questao = response.data || {};
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async getQuestionarios () {
      let vm = this;
      try {
        const response = await vm.$axios.get(`/questionario`);
        vm.loadingQuestionarios = true;
        vm.listQuestionarios = response.data.rows;
      } catch (error) {
        vm.loadingQuestionarios = true;
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar os dados. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },
    customFilter (item, queryText, itemText) {
      const hasValue = val => val != null ? val : '';
      const text = hasValue(item.nome);
      const query = hasValue(queryText);
      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    }
  },
};
</script>

<style scoped>

</style>

